import React from 'react';
import {Col, DropdownButton, Grid, MenuItem, Panel, Row} from 'react-bootstrap';
import {connect} from 'react-redux';
import {actions} from 'react-redux-form';
import {isNull} from 'lodash';
import {getMyStoresListRep as getOutlets} from '../../../../actions/outlet';
import {history} from '../../../../store';

import './list.css';
import OutletSearch from '../../../admin/outlet-list/outlet-search';
import {doPseudoLoginRep} from '../../../../actions/users';
import MessageDialog from '../message-dialog';
import {sendStoreMessage} from '../../../../actions/messages';
import {checkPermission} from '../../../common/guards/can';
import PageTitle from '../../../common/page-title/index';
import withPaginatedFilter from '../../../common/withPaginatedFilter';
import RepOutletTable from './rep-outlet-table';


class MyStoresListView extends React.Component {
  state = {
    showMessageDialog: false,
    outlet: undefined,
    outletName: '',
    ownerName: '',
  };

  openMessageModal = (outlet, outletName, ownerName) => {
    try {
      this.setState({
        showMessageDialog: true,
        outlet,
        outletName,
        ownerName,
      }, () => {
        this.props.dispatch(actions.reset('deep.store_message'));
      });
    } catch (error) { //
      // swallowed modal lib bug error
    }
  };

  renderOutletActions = ({
    id, outlet_name: outletName, owner_name: ownerName, owner_id: ownerId
  }, ...props) => (
    <div {...props}>
      <DropdownButton bsStyle="default" className="red-ghost-btn" title="Actions">
        <MenuItem eventKey="1" onClick={() => history.push(`/team/outlets/${id}`)}>
          View Store
        </MenuItem>
        {checkPermission('view', 'points_rep_area') && ownerName && (
          <MenuItem
            eventKey="2"
            onClick={() => history.push(`/team/outlets/${id}/points-activity`)}
          >
            Points Statement
          </MenuItem>
        )}
        {checkPermission('view', 'messages_rep_area') && ownerName && (
          <MenuItem eventKey="3" onClick={() => this.openMessageModal(id, outletName, ownerName)}>
            Send Message
          </MenuItem>
        )}
        {checkPermission('pseudo-login-read', 'web_app') && ownerName && (
          <MenuItem eventKey="4" disabled={isNull(ownerName)} onClick={() => this.handleStoreDemoClick(ownerId)}>
            Store Demo
          </MenuItem>
        )}
      </DropdownButton>
    </div>
  );

  handleStoreDemoClick = (userId) => {
    const {dispatch} = this.props;

    dispatch(doPseudoLoginRep(userId))
      .then(() => {
        setTimeout(() => {
          localStorage.setItem('rep-pseudo-login-started-from', window.location.href);
          window.location.href = '/';
        }, 2000);
      });
  };

  handleMessageClose = () => {
    this.setState({
      showMessageDialog: false,
      outlet: undefined,
    });
  };

  handleMessageSend = (payload) => {
    const {dispatch} = this.props;
    const {outlet} = this.state;

    const message = {
      ...payload,
      outlet_id: outlet,
    };

    dispatch(sendStoreMessage(message))
      .then(() => {
        dispatch(actions.reset('deep.store_message'));
        this.handleMessageClose();
      });
  };

  render() {
    const {
      outlets, paging, pageNumber, query, handleChange, handleClear, handleSearch, handlePageChange
    } = this.props;
    const {
      showMessageDialog, ownerName, outletName, outlet: outletId
    } = this.state;

    const outletsWithActions = outlets.map((outlet, key) => ({
      ...outlet,
      attributes: {
        ...outlet.attributes,
        actions: this.renderOutletActions({
          key,
          owner_name: outlet.attributes.owner,
          outlet_name: outlet.attributes.name,
          id: outlet.id,
          owner_id: outlet.attributes['owner-id']
        })
      }
    }));

    return (
      <Grid className='rep-store-list'>
        <Row>
          <Col lg={12}>
            <PageTitle>
              My stores
            </PageTitle>
          </Col>
        </Row>
        <OutletSearch
          onChange={handleChange}
          onClear={handleClear}
          onSearch={handleSearch}
          searchValue={query}
          placeholder="Customer unique number, outlet name, postcode, group name"
        />
        <Row>
          <Col lg={12}>
            <Panel className="my-stores-list">
              <RepOutletTable
                outlets={outletsWithActions}
                currentPage={pageNumber}
                onPageChange={handlePageChange}
                paging={paging}
              />
            </Panel>
          </Col>
        </Row>
        {showMessageDialog && (
          <MessageDialog
            onClose={this.handleMessageClose}
            onMessageSend={payLoad => this.handleMessageSend(payLoad)}
            to={`${ownerName}-${outletName}-${outletId}`}
          />
        )}
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  outlets: state.stores.repOutlets,
  paging: state.stores.repPaging,
});

export default connect(mapStateToProps)(withPaginatedFilter(MyStoresListView, getOutlets));




// WEBPACK FOOTER //
// ./src/components/team/my-stores/list/list.jsx